import { create } from 'zustand';
import { LoginResponse, UserAuthState } from '../../types/global/UserAuthTypes';

/**
 * useUserAuthStore
 */

export const useUserAuthStore = create<UserAuthState>((set, get) => ({
  token: localStorage.getItem('token') || null,
  empresaId: Number.parseInt(localStorage.getItem('empresaId') ?? "0"),
  nomeUsuario: localStorage.getItem('nomeUsuario') ?? "",
  idUsuario: localStorage.getItem('idUsuario') ? Number(localStorage.getItem('idUsuario')) : 0,
  login: localStorage.getItem('login') ?? "",
  isTestEnvironment: localStorage.getItem('isTestEnvironment') === 'true',
  notificacoes: null,
  setAuthInfos: (infos: LoginResponse | null) => {
    if (infos != null) {
      localStorage.setItem('token', infos.token)
      localStorage.setItem('empresaId', infos.empresaId.toString())
      localStorage.setItem('empresa', infos.empresa.toString())
      localStorage.setItem('login', infos.login)
      localStorage.setItem('nomeUsuario', infos.nomeUsuario)
      localStorage.setItem('idUsuario', infos.idUsuario.toString())
      localStorage.setItem('isTestEnvironment', JSON.stringify(infos.isTestEnvironment))
      localStorage.setItem('isDevelEnvironment', JSON.stringify(infos.isDevelEnvironment))

      set({
        token: infos.token,
        empresaId: infos.empresaId,
        nomeUsuario: infos.nomeUsuario,
        idUsuario: infos.idUsuario,
        login: infos.login,
        isForcedUserLogout: false,
        notificacoes: infos.notificacoes,
      })
    }
    else {
      localStorage.removeItem('token')
      localStorage.removeItem('empresaId')
      localStorage.removeItem('empresa')
      localStorage.removeItem('login')
      localStorage.removeItem('nomeUsuario')
      localStorage.removeItem('idUsuario')

      set({
        token: null,
        empresaId: 0,
        isForcedUserLogout: false,
        notificacoes: null,
      })
    }
  },
  erro: false,
  setErro: (erro: boolean) => {
    set(() => ({ erro: erro }))
  },
  messageErro: "",
  setMessageErro: (message: string) => {
    set(() => ({ messageErro: message }))
  },
  cleanUserAuthStates: () => {
    localStorage.removeItem('token')
    localStorage.removeItem('empresaId')
    localStorage.removeItem('login')
    localStorage.removeItem('nomeUsuario')
    localStorage.removeItem('idUsuario')
    set(() => ({ token: null, erro: false, messageErro: "", empresaId: 0, login: "", nomeUsuario: "", idUsuario: 0, notificacoes: null, }))
  },
  isForcedUserLogout: false,
  forcedUserLogout: () => {
    localStorage.removeItem('token')
    localStorage.removeItem('empresaId')
    localStorage.removeItem('login')
    localStorage.removeItem('nomeUsuario')
    localStorage.removeItem('idUsuario')
    set(() => ({ token: null, erro: false, messageErro: "", empresaId: 0, login: "", nomeUsuario: "", idUsuario: 0, notificacoes: null, isForcedUserLogout: get().token !== null }))
  },
  clearForcedUserLogout: () => {
    set(() => ({ isForcedUserLogout: false }));
  },
  appendNotificacoes: (notificacoes) => {
    const notificacoesSalvas = get().notificacoes ?? [];
    set(() => ({ notificacoes: [...notificacoesSalvas, ...notificacoes] }));
  },
  clearNotificacoes: () => {
    set(() => ({ notificacoes: null }));
  },
}))
